'use strict';
const foregroundStyle = require('./foreground-style');
module.exports = function nodeStyleFromAttributes(idea, nodeTheme) {
	const validColor = (color) => !['false', 'transparent'].includes(color) && color,
		colorText = nodeTheme.borderType !== 'surround',
		textAlign = idea.attr && idea.attr.style && idea.attr.style.textAlign,
		result = {
			text: {}
		},
		oldPrimary = idea.attr?.style && validColor(idea.attr.style.background),
		borderColor = idea.attr?.style?.borderColor;
	if (idea.attr && idea.attr.style && idea.attr.style.text && validColor(idea.attr.style.text.color)) {
		result.text.color = idea.attr.style.text.color;
	}
	if (textAlign) {
		result.text.alignment = textAlign;
	}
	if (idea.attr && idea.attr.style && validColor(idea.attr.style.backgroundColor)) {
		result.backgroundColor = idea.attr.style.backgroundColor;
	}
	if (oldPrimary) {
		if (colorText) {
			result.text.color = result.text.color || oldPrimary;
		} else if (!result.backgroundColor) {
			result.backgroundColor = oldPrimary;
			result.text.color = result.text.color || nodeTheme.text[foregroundStyle(oldPrimary)];
		}
	}
	if (idea.attr && idea.attr.style && idea.attr.style.fontFamily) {
		result.font = {family: idea.attr.style.fontFamily};
	}
	if (Object.keys(result.text).length === 0) {
		delete result.text;
	}
	if (borderColor && validColor(borderColor)) {
		result.lineColor = borderColor;
	}
	if (Number.isFinite(idea.attr?.style?.borderWidth)) {
		result.lineWidth = idea.attr?.style?.borderWidth;
	}
	if (Number.isFinite(idea.attr?.style?.cornerRadius)) {
		result.cornerRadius = idea.attr?.style?.cornerRadius;
	}
	return result;
};
